import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { dmsState } from '@/app/store'
import { Loader } from '@/shared'
import { routes } from '@Config/config'

import { emptyCompanyData } from '../../helper'
import { GoBack } from '../GoBack/GoBack'

import style from './Company.module.scss'
import { Data } from './Data/Data'

interface IProps {
    type: string
}

export const Company = observer((props: IProps) => {
    const { type } = props
    const { companyId } = useParams()
    const navi = useNavigate()

    useEffect(() => {
        if (type === 'add' && !dmsState.chosenCompany) {
            dmsState.onSetChosenCompany({ add: emptyCompanyData })
        }
    }, [type])

    useEffect(() => {
        if (type === 'edit' && companyId && !dmsState.chosenCompany) {
            dmsState.onGetChosenCompany(companyId, type)
        }
        return () => {
            dmsState.onSetChosenCompany(null)
        }
    }, [companyId, type])

    if (!dmsState.chosenCompany) {
        return <Loader />
    }

    const onHandleGoBack = () => navi(`${routes.DMSM}/companies`)
    return (
        <>
            <GoBack onGoBack={onHandleGoBack} />
            <div className={style.container}>
                <Data type={type} />
            </div>
        </>
    )
})
